import { LightningElement, api, track } from 'lwc';


const COLORS = [
    {color: '#032d60', colorClass: 'color-pill-1'},
    {color: '#9602c7', colorClass: 'color-pill-2'},
    {color: '#640103', colorClass: 'color-pill-3'},
    {color: 'rgb(6, 165, 154)', colorClass: 'color-pill-4'},
    {color: '#2e844a', colorClass: 'color-pill-5'},
    {color: '#fe5c4c', colorClass: 'color-pill-6'},
    {color: '#ff538a', colorClass: 'color-pill-7'},
    {color: '#fe5c4c', colorClass: 'color-pill-8'},
    {color: '#194e31', colorClass: 'color-pill-9'},
    {color: '#032d60', colorClass: 'color-pill-10'},
    {color: '#08abed', colorClass: 'color-pill-11'},
    {color: '#45c65a', colorClass: 'color-pill-12'},
    {color: '#5867e8', colorClass: 'color-pill-13'},
    {color: '#ff906e', colorClass: 'color-pill-14'},
    {color: '#7526e3', colorClass: 'color-pill-15'},
    {color: '#0b827c', colorClass: 'color-pill-16'},
    {color: '#9602c7', colorClass: 'color-pill-17'},
    {color: '#e4a201', colorClass: 'color-pill-18'},
    {color: '#03234d', colorClass: 'blue-1', },
    {color: '#032d60', colorClass: 'blue-2', },
    {color: '#014486', colorClass: 'blue-3', },
    {color: '#0b5cab', colorClass: 'blue-4', },
    {color: '#0176d3', colorClass: 'blue-5', },
    {color: '#1b96ff', colorClass: 'blue-6', },
    {color: '#57a3fd', colorClass: 'blue-7', },
    {color: '#78b0fd', colorClass: 'blue-8', },
    {color: '#aacbff', colorClass: 'blue-9', },
    {color: '#0a2636', colorClass: 'cloud-blue-2', },
    {color: '#023248', colorClass: 'cloud-blue-3', },
    {color: '#084968', colorClass: 'cloud-blue-4', },
    {color: '#05628a', colorClass: 'cloud-blue-5', },
    {color: '#107cad', colorClass: 'cloud-blue-6', },
    {color: '#0d9dda', colorClass: 'cloud-blue-7', },
    {color: '#08abed', colorClass: 'cloud-blue-8', },
    {color: '#1ab9ff', colorClass: 'cloud-blue-9', },
    {color: '#90d0fe', colorClass: 'cloud-blue-10', },
    {color: '#1c3326', colorClass: 'green-3', },
    {color: '#194e31', colorClass: 'green-4', },
    {color: '#396547', colorClass: 'green-5', },
    {color: '#2e844a', colorClass: 'green-6', },
    {color: '#3ba755', colorClass: 'green-7', },
    {color: '#41b658', colorClass: 'green-8', },
    {color: '#45c65a', colorClass: 'green-9', },
    {color: '#91db8b', colorClass: 'green-10', },
    {color: '#cdefc4', colorClass: 'green-11', },
    {color: '#421604', colorClass: 'hot-orange-2', },
    {color: '#4a2413', colorClass: 'hot-orange-3', },
    {color: '#7e2600', colorClass: 'hot-orange-4', },
    {color: '#aa3001', colorClass: 'hot-orange-5', },
    {color: '#d83a00', colorClass: 'hot-orange-6', },
    {color: '#ff5d2d', colorClass: 'hot-orange-7', },
    {color: '#ff784f', colorClass: 'hot-orange-8', },
    {color: '#ff906e', colorClass: 'hot-orange-9', },
    {color: '#feb9a5', colorClass: 'hot-orange-10', }, 
    {color: '#1f0974', colorClass: 'indigo-2', },
    {color: '#321d71', colorClass: 'indigo-3', },   
    {color: '#2f2cb7', colorClass: 'indigo-4', },
    {color: '#3a49da', colorClass: 'indigo-5', },
    {color: '#5867e8', colorClass: 'indigo-6', },
    {color: '#7f8ced', colorClass: 'indigo-7', },
    {color: '#8e9bef', colorClass: 'indigo-8', },
    {color: '#9ea9f1', colorClass: 'indigo-9', },
    {color: '#bec7f6', colorClass: 'indigo-10', },
    {color: '#3e2b02', colorClass: 'orange-3', },
    {color: '#5f3e02', colorClass: 'orange-4', },
    {color: '#825101', colorClass: 'orange-5', },
    {color: '#a96404', colorClass: 'orange-6', },
    {color: '#dd7a01', colorClass: 'orange-7', },
    {color: '#f38303', colorClass: 'orange-8', },
    {color: '#fe9339', colorClass: 'orange-9', },
    {color: '#ffba90', colorClass: 'orange-10', },
    {color: '#ffba90', colorClass: 'orange-11', },
    {color: '#8a033e', colorClass: 'pink-2', },
    {color: '#8a033e', colorClass: 'pink-3', },
    {color: '#8a033e', colorClass: 'pink-4', },
    {color: '#b60554', colorClass: 'pink-5', },
    {color: '#e3066a', colorClass: 'pink-6', },
    {color: '#ff538a', colorClass: 'pink-7', },
    {color: '#fe7298', colorClass: 'pink-8', },
    {color: '#fe8aa7', colorClass: 'pink-9', },
    {color: '#fdb6c5', colorClass: 'pink-10', },
    {color: '#5a1ba9', colorClass: 'purple-3', },
    {color: '#5a1ba9', colorClass: 'purple-4', },
    {color: '#7526e3', colorClass: 'purple-5', },
    {color: '#9050e9', colorClass: 'purple-6', },
    {color: '#ad7bee', colorClass: 'purple-7', },
    {color: '#b78def', colorClass: 'purple-8', },
    {color: '#c29ef1', colorClass: 'purple-9', },
    {color: '#d7bff2', colorClass: 'purple-10', },
    {color: '#ece1f9', colorClass: 'purple-11', },
    {color: '#640103', colorClass: 'red-3', },
    {color: '#8e030f', colorClass: 'red-4', },
    {color: '#ba0517', colorClass: 'red-5', },
    {color: '#ea001e', colorClass: 'red-6', },
    {color: '#fe5c4c', colorClass: 'red-7', },
    {color: '#fe7765', colorClass: 'red-8', },
    {color: '#fe8f7d', colorClass: 'red-9', },
    {color: '#feb8ab', colorClass: 'red-10', },
    {color: '#feded8', colorClass: 'red-11', },
    {color: '#023434', colorClass: 'teal-3', },
    {color: '#024d4c', colorClass: 'teal-4', },
    {color: '#056764', colorClass: 'teal-5', },
    {color: '#0b827c', colorClass: 'teal-6', },
    {color: '#06a59a', colorClass: 'teal-7', },
    {color: '#03b4a7', colorClass: 'teal-8', },
    {color: '#01c3b3', colorClass: 'teal-9', },
    {color: '#04e1cb', colorClass: 'teal-10', },
    {color: '#acf3e4', colorClass: 'teal-11', },
    {color: '#481a54', colorClass: 'violet-3', },
    {color: '#730394', colorClass: 'violet-4', },
    {color: '#9602c7', colorClass: 'violet-5', },
    {color: '#ba01ff', colorClass: 'violet-6', },
    {color: '#cb65ff', colorClass: 'violet-7', },
    {color: '#d17dfe', colorClass: 'violet-8', },
    {color: '#d892fe', colorClass: 'violet-9', },
    {color: '#e5b9fe', colorClass: 'violet-10', },
    {color: '#f2defe', colorClass: 'violet-11', },
    {color: '#4f2100', colorClass: 'yellow-3', },
    {color: '#6f3400', colorClass: 'yellow-4', },
    {color: '#8c4b02', colorClass: 'yellow-5', },
    {color: '#a86403', colorClass: 'yellow-6', },
    {color: '#ca8501', colorClass: 'yellow-7', },
    {color: '#d79304', colorClass: 'yellow-8', },
    {color: '#e4a201', colorClass: 'yellow-9', },
    {color: '#fcc003', colorClass: 'yellow-10', },
    {color: '#f9e3b6', colorClass: 'yellow-11', },
    {color: '#181818', colorClass: 'neutral-1', },
    {color: '#242424', colorClass: 'neutral-2', },
    {color: '#2e2e2e', colorClass: 'neutral-3', },
    {color: '#5c5c5c', colorClass: 'neutral-5', },
    {color: '#747474', colorClass: 'neutral-6', },
    {color: '#a0a0a0', colorClass: 'neutral-8', },
    {color: '#aeaeae', colorClass: 'neutral-9', },
    {color: '#e5e5e5', colorClass: 'neutral-11', },
    {color: '#f3f3f3', colorClass: 'neutral-12', },
];


export default class customButtonIconsListBox extends LightningElement {
    static renderMode = 'light';
    @track fieldsCounter = 2000;
    @track buttonsCounts = 3000;
    @track _options = [];        // ← make this tracked (Enables Reactivity)


    @api 
    set options(value) {
        console.log('getting a new value in custom buttons listsbox: ', JSON.stringify(value));
        this._options = JSON.parse(JSON.stringify(value)).map(option => {
            const crntColor = Array.isArray(option?.color) ? option?.color[0] || null : option?.color || null
            
            return { 
                ...option, 
                textClass: `pill-color-box ${ COLORS.find(c => 
                    c.color === crntColor
                ).colorClass || 'default-text'}`,
                keyId: `${option.label}-${this.fieldsCounter++}`,
                buttons: option.buttons.map(btn => {
                    return {
                        ...btn,
                        keyId: `${this.buttonsCounts++}`,
                        value: `${option.fieldName}—${btn.action}`  // Use em-dash — (not hyphen)
                    }
                })
            }
        });
    }
    get options() {
        return this._options;
    }


    // Send event when a button is clicked
    handleClick(event) {
        const value = event.target.value;
        console.log('here is the value in handleClick of customButtonIconsListBox: ', value);
        const [fieldName, action] = value.split('—');
        this.dispatchEvent(new CustomEvent('iconslistboxclick', {
            detail: { fieldName: fieldName, action: action },
            bubbles: true // Light DOM bubbles
        }));
    }

}